var map = {
	"./antonio-di-marino.jpg": "ff90",
	"./antonio-passarella.jpg": "1cb9",
	"./avatar.png": "bb3c",
	"./francesca-scozzari.jpg": "a8f7",
	"./gregorio-palama.png": "1895",
	"./simone-dinardodimaio.jpg": "64f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b270";